export const footer = {
    content: [
        {
            title: '凤凰新媒体介绍',
            url: '//www.ifeng.com/corp/about/intro/',
        },
        {
            title: '投资者关系 Investor Relations',
            url: '//ir.ifeng.com/',
        },
        {
            title: '广告服务',
            url: '//biz.ifeng.com/',
        },
        {
            title: '诚征英才',
            url: '//career.ifeng.com/',
        },
        {
            title: '保护隐私权',
            url: '//www.ifeng.com/corp/privacy/',
        },
        {
            title: '免责条款',
            url: '//www.ifeng.com/corp/exemption/',
        },
        {
            title: '意见反馈',
            url: '//www.ifeng.com/corp/feedback/',
        },
        {
            title: '凤凰卫视介绍',
            url: '//phtv.ifeng.com/intro/',
        },
        {
            text0: '凤凰新媒体',
            text1: '版权所有',
            text2: 'Copyright © 2016 Phoenix New Media Limited All Rights Reserved.',
        },
    ],
};
